import React from 'react'
import { ButtonBase, Collapse, Drawer, IconButton, MenuItem } from '@material-ui/core'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded'
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded'
import './SlideMenu.styles.scss'

// left slide menu used on mobile (main menu, page actions)
// top is rendered above the items (e.g. the company block), footer is pinned to the bottom
export const SlideMenu = ({ open, onClose, title, top, footer, children }) => (
    <Drawer
        anchor="left"
        open={open}
        onClose={onClose}
        classes={{ paper: 'slideMenu' }}
    >
        <div className="slideMenuHeader">
            <span className="slideMenuTitle">{title}</span>
            <IconButton className="slideMenuClose" aria-label="Close" onClick={onClose}>
                <CloseRoundedIcon />
            </IconButton>
        </div>
        <div className="slideMenuScroll">
            {top}
            <div className="slideMenuList">{children}</div>
        </div>
        {footer && <div className="slideMenuFooter">{footer}</div>}
    </Drawer>
)

// entry with an icon block, expands its children under itself when there are any,
// group sets the accent colour the same way as on the quick add tiles
export const SlideMenuSection = ({ id, icon: Icon, label, hint, group, active, expanded, onClick, children }) => {
    const expandable = Boolean(children)
    const classNames = ['slideMenuSection', group, expanded && 'expanded', active && 'active'].filter(Boolean).join(' ')

    return (
        <div className={classNames}>
            <ButtonBase id={id} className="slideMenuItem" onClick={onClick}>
                <span className="slideMenuIcon">
                    <Icon />
                </span>
                <span className="slideMenuText">
                    <span className="slideMenuLabel">{label}</span>
                    {hint && <span className="slideMenuHint">{hint}</span>}
                </span>
                {expandable && <ExpandMoreRoundedIcon className="slideMenuChevron" />}
            </ButtonBase>
            {expandable && (
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <div className="slideMenuSubList">{children}</div>
                </Collapse>
            )}
        </div>
    )
}

// item of an expanded section, expands one more level when it has children
export const SlideMenuSubItem = ({ id, label, active, expanded, disabled, onClick, children }) => {
    const expandable = Boolean(children)
    const classNames = ['slideMenuSubItem', expanded && 'expanded', active && 'active'].filter(Boolean).join(' ')

    return (
        <>
            <MenuItem id={id} className={classNames} disabled={disabled} onClick={onClick}>
                <span className="slideMenuSubItemLabel">{label}</span>
                {expandable && <ExpandMoreRoundedIcon className="slideMenuChevron" />}
            </MenuItem>
            {expandable && (
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <div className="slideMenuSubList nested">{children}</div>
                </Collapse>
            )}
        </>
    )
}
